import type { CSSProperties } from "react";

/**
 * Überlagerungen (mitlaufender CTA, Bildnachweis) in einer Bühne, die kleiner
 * ist als ein Handy (Jans Fund 05.10.2026): Die Galerie-Kachel mountet
 * Bild-Vorlagen in ihrer echten Größe (~210 px breit, s. TemplateHoverPreview).
 * Der CTA hat aber Handy-Pixel (Emoji-Knöpfe 36 px, Schrift 16 px) und stand
 * dort riesig in der Kachel, die Emojis brachen in zwei Spalten um.
 *
 * Lösung: den Anker auf Handybreite setzen (`100 / s` Prozent der Bühne) und
 * per transform auf die Bühne verkleinern, verankert unten links. Der Inhalt
 * bricht dann um wie auf dem Handy und sieht aus wie dort, nur kleiner.
 * transform statt `zoom`: verändert das Layout drumherum nicht und rechnet in
 * allen Browsern gleich.
 *
 * `s` außerhalb von (0, 1) → keine Änderung (normale Bühnen, Leser).
 */
export function ueberlagerungMassstabStil(s: number | undefined): CSSProperties {
    if (s === undefined || !(s > 0) || s >= 1) return {};
    return {
        right: "auto",
        width: `${(100 / s).toFixed(3)}%`,
        transform: `scale(${s.toFixed(4)})`,
        transformOrigin: "bottom left",
    };
}
